/*
 *
 * ModifyNumberModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 09-Sep-2024
*/

import ModifyNumberModal from './ModifyNumberModalContainer'

export default ModifyNumberModal
